(function () {
  var CACHE_TTL    = 3600000;
  var KEY_COUNTRY  = 'fu_country';
  var KEY_RATE_CAD = 'fu_cad_rate';
  var KEY_RATE_CHF = 'fu_chf_rate';

  function getCache(k) {
    try {
      var o = JSON.parse(localStorage.getItem(k));
      if (o && Date.now() - o.ts < CACHE_TTL) return o.v;
    } catch (e) {}
    return null;
  }

  function setCache(k, v) {
    try { localStorage.setItem(k, JSON.stringify({ v: v, ts: Date.now() })); } catch (e) {}
  }

  function convertPrices(rate, formatFn, badgeId, badgeHtml) {
    document.querySelectorAll('.money.conversion-bear-money').forEach(function (el) {
      if (el.getAttribute('data-converted')) return;
      var raw = el.textContent.trim();
      var num = parseFloat(raw.replace(/\s/g, '').replace(/[^\d,]/g, '').replace(',', '.'));
      if (isNaN(num) || num === 0) return;
      el.textContent = formatFn(num * rate);
      el.setAttribute('data-converted', '1');
      el.setAttribute('title', 'Prix indicatif - paiement en EUR');
    });

    if (!document.getElementById(badgeId)) {
      var b = document.createElement('div');
      b.id = badgeId;
      b.style.cssText = 'position:fixed;bottom:70px;left:12px;z-index:9999;background:#fff8ec;border:1px solid #d7cec7;border-radius:6px;padding:6px 12px;font-size:11px;color:#888;box-shadow:0 1px 4px rgba(0,0,0,.1)';
      b.innerHTML = badgeHtml;
      document.body.appendChild(b);
    }
  }

  function applyConversion(rate, formatFn, badgeId, badgeHtml) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { convertPrices(rate, formatFn, badgeId, badgeHtml); });
    } else {
      convertPrices(rate, formatFn, badgeId, badgeHtml);
    }
    document.addEventListener('variantChange', function () { convertPrices(rate, formatFn, badgeId, badgeHtml); });
  }

  function fetchRate(currency, cacheKey, fallback, cb) {
    var cached = getCache(cacheKey);
    if (cached) return cb(cached);
    fetch('https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@latest/v1/currencies/eur.json')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var rate = d.eur && d.eur[currency];
        if (rate) { setCache(cacheKey, rate); cb(rate); }
      })
      .catch(function () { cb(fallback); });
  }

  function checkCountry(country) {
    if (country === 'CA') {
      fetchRate('cad', KEY_RATE_CAD, 1.50, function (rate) {
        applyConversion(
          rate,
          function (n) { return n.toFixed(2).replace('.', ',') + ' $ CA'; },
          'fu-cad-badge',
          '&#127464;&#127462; Prix en $CA indicatifs (taux du jour)<br><small>Le paiement s\'effectue en €</small>'
        );
      });
    }

    if (country === 'CH') {
      fetchRate('chf', KEY_RATE_CHF, 0.95, function (rate) {
        applyConversion(
          rate,
          function (n) { return n.toFixed(2) + ' CHF'; },
          'fu-chf-badge',
          '&#127464;&#127469; Prix en CHF indicatifs (taux du jour)<br><small>Le paiement s\'effectue en €</small>'
        );
      });
    }
  }

  var cachedCountry = getCache(KEY_COUNTRY);
  if (cachedCountry) {
    checkCountry(cachedCountry);
  } else {
    fetch('https://ipapi.co/country/')
      .then(function (r) { return r.text(); })
      .then(function (c) {
        c = c.trim().toUpperCase();
        setCache(KEY_COUNTRY, c);
        checkCountry(c);
      })
      .catch(function () {});
  }
})();
